import { createAsyncAction } from "typesafe-actions";
import { Language } from "../../blocks/localization/Language";
import Account from "../../models/account/Account";
import { ChangePasswordRequest } from "../../models/account/change-password/ChangePasswordRequest";
import { ForgotPasswordRequest } from "../../models/account/forgot-password/ForgotPasswordRequest";
import { RegisterRequest } from "../../models/account/register/RegisterRequest";
import { ResetPasswordRequest } from "../../models/account/reset-password/ResetPasswordRequest";
import { UpdateUserRequest } from "../../models/account/update-user/UpdateUserRequest";
import { VerifyActivationMailRequest } from "../../models/account/verify-activation-mail/VerifyActivationMailRequest";
import { VerifyEmailRequest } from "../../models/account/verify-email/VerifyEmailRequest";
import { ActivateFullProfileRequest } from "../../models/profile/ActivateProfileRequest";
import {
    ActivateFullProfileActionTypes,
    ChangeLanguageActionTypes,
    ChangePasswordActionTypes,
    RefreshProfilesActionTypes as RefreshProfilesActionTypes,
    ForgotPasswordActionTypes,
    GetAccountActionTypes,
    GetIsFullProfileActivationInProgressActionTypes,
    RegisterActionTypes,
    ResetPasswordActionTypes,
    UpdateUserActionTypes,
    VerifyActivationMailActionTypes,
    VerifyEmailActionTypes
} from "./types";

export const changeLanguageActions = createAsyncAction(
    ChangeLanguageActionTypes.REQUEST,
    ChangeLanguageActionTypes.SUCCESS,
    ChangeLanguageActionTypes.ERROR
)<Language, undefined, undefined>();

export const getAccountActions = createAsyncAction(
    GetAccountActionTypes.REQUEST,
    GetAccountActionTypes.SUCCESS,
    GetAccountActionTypes.ERROR
)<undefined, Account, undefined>();

export const registerActions = createAsyncAction(
    RegisterActionTypes.REQUEST,
    RegisterActionTypes.SUCCESS,
    RegisterActionTypes.ERROR
)<RegisterRequest, undefined, undefined>();

export const forgotPasswordActions = createAsyncAction(
    ForgotPasswordActionTypes.REQUEST,
    ForgotPasswordActionTypes.SUCCESS,
    ForgotPasswordActionTypes.ERROR
)<ForgotPasswordRequest, undefined, undefined>();

export const resetPasswordActions = createAsyncAction(
    ResetPasswordActionTypes.REQUEST,
    ResetPasswordActionTypes.SUCCESS,
    ResetPasswordActionTypes.ERROR
)<ResetPasswordRequest, undefined, undefined>();

export const changePasswordActions = createAsyncAction(
    ChangePasswordActionTypes.REQUEST,
    ChangePasswordActionTypes.SUCCESS,
    ChangePasswordActionTypes.ERROR
)<ChangePasswordRequest, undefined, undefined>();

export const updateUserActions = createAsyncAction(
    UpdateUserActionTypes.REQUEST,
    UpdateUserActionTypes.SUCCESS,
    UpdateUserActionTypes.ERROR
)<UpdateUserRequest, undefined, undefined>();

export const verifyActivationMailActions = createAsyncAction(
    VerifyActivationMailActionTypes.REQUEST,
    VerifyActivationMailActionTypes.SUCCESS,
    VerifyActivationMailActionTypes.ERROR
)<VerifyActivationMailRequest, undefined, undefined>();

export const verifyEmailActions = createAsyncAction(
    VerifyEmailActionTypes.REQUEST,
    VerifyEmailActionTypes.SUCCESS,
    VerifyEmailActionTypes.ERROR
)<VerifyEmailRequest, undefined, undefined>();

export const activateFullProfileActions = createAsyncAction(
    ActivateFullProfileActionTypes.REQUEST,
    ActivateFullProfileActionTypes.SUCCESS,
    ActivateFullProfileActionTypes.ERROR
)<ActivateFullProfileRequest, undefined, undefined>();

export const getIsFullProfileActivationInProgressActions = createAsyncAction(
    GetIsFullProfileActivationInProgressActionTypes.REQUEST,
    GetIsFullProfileActivationInProgressActionTypes.SUCCESS,
    GetIsFullProfileActivationInProgressActionTypes.ERROR
)<undefined, boolean, undefined>();

export const refreshProfilesActions = createAsyncAction(
    RefreshProfilesActionTypes.REQUEST,
    RefreshProfilesActionTypes.SUCCESS,
    RefreshProfilesActionTypes.ERROR
)<number, boolean, undefined>();
